import { render, staticRenderFns } from "./projectInfo.vue?vue&type=template&id=4cc6c97c&scoped=true"
import script from "./projectInfo.vue?vue&type=script&lang=js"
export * from "./projectInfo.vue?vue&type=script&lang=js"
import style0 from "./projectInfo.vue?vue&type=style&index=0&id=4cc6c97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6c97c",
  null
  
)

export default component.exports